module.exports = __webpack_public_path__ + "static/media/app-logo.078593e9.svg";